// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import debateMindLogo from "../assets/debate-mind-ai.png";
// import "../styles/admin/Login.css";

// const AdminLogin = () => {
//   const navigate = useNavigate();
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [errorMsg, setErrorMsg] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setErrorMsg("");

//     try {
  
//     const response = await fetch(`${process.env.REACT_APP_BACKEND_API}/talkshow-admin-web-login/`, {
//       //const response = await fetch("http://192.168.1.10:8000/api/talkshow-admin-web-login/", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({     
//           email: email,
//           password: password
//         })
//       });

//       console.log("response",response);
      

//       if (!response.ok) {
//         throw new Error("Invalid admin credentials");
//       }

//       const data = await response.json();
//       // Store admin token if needed
//       localStorage.setItem("user_role","admin");
      
//       navigate("/admin-panel");
//     } catch (error) {
//       setErrorMsg(error.message || "Admin login failed");
//     }
//   };

//   return (
//     <div className="admin-form-wrapper">
//       <div className="admin-form-header">
//         <img src={debateMindLogo} className="admin-logo" alt="Admin Portal Logo" />
//       </div>

//       <h2 className="admin-form-title">Admin Portal Sign In</h2>

//       <form className="admin-login-form" onSubmit={handleSubmit}>
//         <label className="admin-form-label">Admin Email<span style={{ color: "red" }}>*</span></label>
//         <input
//           type="email"
//           className="admin-form-input"
//           placeholder="Admin Email Address"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           required
//         />

//         <label className="admin-form-label">Password<span style={{ color: "red" }}>*</span></label>
//         <input
//           type="password"
//           className="admin-form-input"
//           placeholder="Enter Admin Password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//         />

//         {errorMsg && <p className="admin-error-message">{errorMsg}</p>}

//         <button type="submit" className="admin-submit-button">
//           Sign In
//         </button>
//       </form>
//     </div>
//   );
// };

// export default AdminLogin;


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import debateMindLogo from "../assets/debate-mind-ai.png";
import "../styles/admin/Login.css";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  // Use CRA environment variable
  const baseUrl = process.env.REACT_APP_BACKEND_API?.replace(/\/$/, "");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    try {
      const response = await fetch(`${baseUrl}/talkshow-admin-web-login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const message =
          errorData?.message || "Invalid admin credentials. Please try again.";
        throw new Error(message);
      }

      const data = await response.json();
      console.log("Admin login success:", data);

      // Save admin role + token if backend returns it
      if (data.token) localStorage.setItem("admin_token", data.token);
      localStorage.setItem("user_role", "admin");

      navigate("/admin-panel");
    } catch (error) {
      console.error("Admin login failed:", error);
      setErrorMsg(error.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-form-wrapper">
      <div className="admin-form-header">
        <img
          src={debateMindLogo}
          className="admin-logo"
          alt="Admin Portal Logo"
        />
      </div>

      <h2 className="admin-form-title">Admin Portal Sign In</h2>

      <form className="admin-login-form" onSubmit={handleSubmit}>
        <label className="admin-form-label">
          Admin Email<span style={{ color: "red" }}>*</span>
        </label>
        <input
          type="email"
          className="admin-form-input"
          placeholder="Admin Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label className="admin-form-label">
          Password<span style={{ color: "red" }}>*</span>
        </label>
        <input
          type="password"
          className="admin-form-input"
          placeholder="Enter Admin Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {errorMsg && <p className="admin-error-message">{errorMsg}</p>}

        <button
          type="submit"
          className="admin-submit-button"
          disabled={loading}
        >
          {loading ? "Signing In..." : "Sign In"}
        </button>
      </form>
    </div>
  );
};
 
export default AdminLogin;

